import { useLingui } from '@lingui/react/macro';
import { memo, type ReactElement } from 'react';

import { SimpleTooltip } from '@/components/tooltips/simple-tooltip';

export type LockedFeatureTooltipProps = {
  locked: boolean;
  children: ReactElement;
  message?: string;
};

export const LockedFeatureTooltip = memo(function LockedFeatureTooltip({
  locked,
  children,
  message,
}: LockedFeatureTooltipProps) {
  const { t } = useLingui();

  if (!locked) {
    return children;
  }

  return (
    <SimpleTooltip
      delayDuration={0}
      title={message ?? t`Upgrade your plan to use this feature`}
    >
      <span className='inline-flex cursor-help'>{children}</span>
    </SimpleTooltip>
  );
});
